let viewportObserver = null;

const obsCallback = function (entries, observer) {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			if (entry.target.classList.contains('_js_inViewport')) {
				entry.target.classList.add('__js_onScreen');
			}
			if (entry.target.classList.contains('element--inviewport')) {
				document.querySelector('.audio__wrapper').classList.add('desc--visible');
			}
			if (entry.target.classList.contains('article__image')) {
				entry.target.querySelector('img').classList.add('article__image--visible');
			}
			if (entry.target.classList.contains('__js_preload')) {
				const srcS = entry.target.getAttribute('data-src');
				(entry.target).style.opacity = '0.3';
				entry.target.setAttribute('src', srcS);
				(entry.target).style.opacity = '1';
				entry.target.classList.remove('__js_preload');
				observer.unobserve(entry.target);
			}
		} else if (
			entry.target.classList.contains('_js_inViewport')
			&& entry.target.classList.contains('__js_onScreen')
		) {
			// entry.target.classList.remove('__js_onScreen');
			observer.unobserve(entry.target);
		} else if (entry.target.classList.contains('element--inviewport')) {
			document.querySelector('.audio__wrapper').classList.remove('desc--visible');
		}
	});
};

export function inViewport() {
	const animatedElements = document.querySelectorAll(
		'._js_inViewport, .__js_preload, .article__image, .element--inviewport',
	);

	viewportObserver = new IntersectionObserver(obsCallback, {
		root: null,
		threshold: 0,
	});

	animatedElements.forEach((elem) => {
		viewportObserver.observe(elem);
	});
}

export function observeNewElements(elements) {
	if (!viewportObserver) return;
	elements.forEach((elem) => viewportObserver.observe(elem));
}
